<template>
  <div class="payment-status">
    <div class="page__title">{{ $t("payment_status.title") }}</div>
    <div class="payment-status__content">
      <div class="payment-status__title">
        {{ $t("payment_status.success_title") }}
      </div>
      <div class="payment-status__amount">
        {{ $t("amount") }} {{ orderTotal }} {{ $t("currency") }}
      </div>
      <div class="payment-status__actions">
        <!--        <div-->
        <!--          class="payment-status__action payment-status__action&#45;&#45;print"-->
        <!--          :class="{ disabled: this.receiptLoading }"-->
        <!--          @click="loadOrderReceipts"-->
        <!--        >-->
        <!--          <div class="payment-status__action-icon">-->
        <!--            <svg-->
        <!--              width="19"-->
        <!--              height="19"-->
        <!--              viewBox="0 0 19 19"-->
        <!--              fill="none"-->
        <!--              xmlns="http://www.w3.org/2000/svg"-->
        <!--            >-->
        <!--              <path-->
        <!--                d="M16.2168 4.78711H15.6973V2.7832C15.6973 1.24854 14.4487 0 12.9141 0H6.08594C4.55128 0 3.30273 1.24854 3.30273 2.7832V4.78711H2.7832C1.24854 4.78711 0 6.03565 0 7.57031V12.0234C0 13.5581 1.24854 14.8066 2.7832 14.8066H3.30273V17.3301C3.30273 18.2509 4.05186 19 4.97266 19H14.0273C14.9481 19 15.6973 18.2509 15.6973 17.3301V14.8066H16.2168C17.7515 14.8066 19 13.5581 19 12.0234V7.57031C19 6.03565 17.7515 4.78711 16.2168 4.78711ZM4.41602 2.7832C4.41602 1.86241 5.16514 1.11328 6.08594 1.11328H12.9141C13.8349 1.11328 14.584 1.86241 14.584 2.7832V4.78711H4.41602V2.7832ZM14.584 17.3301C14.584 17.637 14.3343 17.8867 14.0273 17.8867H4.97266C4.66572 17.8867 4.41602 17.637 4.41602 17.3301V11.8379H14.584V17.3301ZM17.8867 12.0234C17.8867 12.9442 17.1376 13.6934 16.2168 13.6934H15.6973V11.8379H16.0312C16.3387 11.8379 16.5879 11.5887 16.5879 11.2812C16.5879 10.9738 16.3387 10.7246 16.0312 10.7246H2.96875C2.66134 10.7246 2.41211 10.9738 2.41211 11.2812C2.41211 11.5887 2.66134 11.8379 2.96875 11.8379H3.30273V13.6934H2.7832C1.86241 13.6934 1.11328 12.9442 1.11328 12.0234V7.57031C1.11328 6.64952 1.86241 5.90039 2.7832 5.90039H16.2168C17.1376 5.90039 17.8867 6.64952 17.8867 7.57031V12.0234Z"-->
        <!--                fill="#5C91F2"-->
        <!--              />-->
        <!--              <path-->
        <!--                d="M10.9844 13.0996H8.01562C7.70821 13.0996 7.45898 13.3488 7.45898 13.6562C7.45898 13.9637 7.70821 14.2129 8.01562 14.2129H10.9844C11.2918 14.2129 11.541 13.9637 11.541 13.6562C11.541 13.3488 11.2918 13.0996 10.9844 13.0996Z"-->
        <!--                fill="#5C91F2"-->
        <!--              />-->
        <!--              <path-->
        <!--                d="M10.9844 15.4746H8.01562C7.70821 15.4746 7.45898 15.7238 7.45898 16.0312C7.45898 16.3387 7.70821 16.5879 8.01562 16.5879H10.9844C11.2918 16.5879 11.541 16.3387 11.541 16.0312C11.541 15.7238 11.2918 15.4746 10.9844 15.4746Z"-->
        <!--                fill="#5C91F2"-->
        <!--              />-->
        <!--              <path-->
        <!--                d="M4.75 7.16211H2.96875C2.66134 7.16211 2.41211 7.41134 2.41211 7.71875C2.41211 8.02616 2.66134 8.27539 2.96875 8.27539H4.75C5.05741 8.27539 5.30664 8.02616 5.30664 7.71875C5.30664 7.41134 5.05741 7.16211 4.75 7.16211Z"-->
        <!--                fill="#5C91F2"-->
        <!--              />-->
        <!--            </svg>-->
        <!--          </div>-->
        <!--          <div class="payment-status__action-text">-->
        <!--            {{-->
        <!--              receiptLoading-->
        <!--                ? $t("loading")-->
        <!--                : $t("payment_status.action.print_receipt")-->
        <!--            }}-->
        <!--          </div>-->
        <!--        </div>-->
        <div
          class="payment-status__action payment-status__action--print"
          :class="{ disabled: this.receiptLoading }"
          @click="loadOrderPDFReceipt('payment')"
        >
          <div class="payment-status__action-icon">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.2168 4.78711H15.6973V2.7832C15.6973 1.24854 14.4487 0 12.9141 0H6.08594C4.55128 0 3.30273 1.24854 3.30273 2.7832V4.78711H2.7832C1.24854 4.78711 0 6.03565 0 7.57031V12.0234C0 13.5581 1.24854 14.8066 2.7832 14.8066H3.30273V17.3301C3.30273 18.2509 4.05186 19 4.97266 19H14.0273C14.9481 19 15.6973 18.2509 15.6973 17.3301V14.8066H16.2168C17.7515 14.8066 19 13.5581 19 12.0234V7.57031C19 6.03565 17.7515 4.78711 16.2168 4.78711ZM4.41602 2.7832C4.41602 1.86241 5.16514 1.11328 6.08594 1.11328H12.9141C13.8349 1.11328 14.584 1.86241 14.584 2.7832V4.78711H4.41602V2.7832ZM14.584 17.3301C14.584 17.637 14.3343 17.8867 14.0273 17.8867H4.97266C4.66572 17.8867 4.41602 17.637 4.41602 17.3301V11.8379H14.584V17.3301ZM17.8867 12.0234C17.8867 12.9442 17.1376 13.6934 16.2168 13.6934H15.6973V11.8379H16.0312C16.3387 11.8379 16.5879 11.5887 16.5879 11.2812C16.5879 10.9738 16.3387 10.7246 16.0312 10.7246H2.96875C2.66134 10.7246 2.41211 10.9738 2.41211 11.2812C2.41211 11.5887 2.66134 11.8379 2.96875 11.8379H3.30273V13.6934H2.7832C1.86241 13.6934 1.11328 12.9442 1.11328 12.0234V7.57031C1.11328 6.64952 1.86241 5.90039 2.7832 5.90039H16.2168C17.1376 5.90039 17.8867 6.64952 17.8867 7.57031V12.0234Z"
                fill="#5C91F2"
              />
              <path
                d="M10.9844 13.0996H8.01562C7.70821 13.0996 7.45898 13.3488 7.45898 13.6562C7.45898 13.9637 7.70821 14.2129 8.01562 14.2129H10.9844C11.2918 14.2129 11.541 13.9637 11.541 13.6562C11.541 13.3488 11.2918 13.0996 10.9844 13.0996Z"
                fill="#5C91F2"
              />
              <path
                d="M10.9844 15.4746H8.01562C7.70821 15.4746 7.45898 15.7238 7.45898 16.0312C7.45898 16.3387 7.70821 16.5879 8.01562 16.5879H10.9844C11.2918 16.5879 11.541 16.3387 11.541 16.0312C11.541 15.7238 11.2918 15.4746 10.9844 15.4746Z"
                fill="#5C91F2"
              />
              <path
                d="M4.75 7.16211H2.96875C2.66134 7.16211 2.41211 7.41134 2.41211 7.71875C2.41211 8.02616 2.66134 8.27539 2.96875 8.27539H4.75C5.05741 8.27539 5.30664 8.02616 5.30664 7.71875C5.30664 7.41134 5.05741 7.16211 4.75 7.16211Z"
                fill="#5C91F2"
              />
            </svg>
          </div>
          <div class="payment-status__action-text">
            {{
              receiptLoading
                ? $t("loading")
                : $t("payment_status.action.print_receipt_payment")
            }}
          </div>
        </div>
        <div
          class="payment-status__action payment-status__action--print"
          :class="{ disabled: this.receiptLoading }"
          @click="loadOrderPDFReceipt('commission')"
        >
          <div class="payment-status__action-icon">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.2168 4.78711H15.6973V2.7832C15.6973 1.24854 14.4487 0 12.9141 0H6.08594C4.55128 0 3.30273 1.24854 3.30273 2.7832V4.78711H2.7832C1.24854 4.78711 0 6.03565 0 7.57031V12.0234C0 13.5581 1.24854 14.8066 2.7832 14.8066H3.30273V17.3301C3.30273 18.2509 4.05186 19 4.97266 19H14.0273C14.9481 19 15.6973 18.2509 15.6973 17.3301V14.8066H16.2168C17.7515 14.8066 19 13.5581 19 12.0234V7.57031C19 6.03565 17.7515 4.78711 16.2168 4.78711ZM4.41602 2.7832C4.41602 1.86241 5.16514 1.11328 6.08594 1.11328H12.9141C13.8349 1.11328 14.584 1.86241 14.584 2.7832V4.78711H4.41602V2.7832ZM14.584 17.3301C14.584 17.637 14.3343 17.8867 14.0273 17.8867H4.97266C4.66572 17.8867 4.41602 17.637 4.41602 17.3301V11.8379H14.584V17.3301ZM17.8867 12.0234C17.8867 12.9442 17.1376 13.6934 16.2168 13.6934H15.6973V11.8379H16.0312C16.3387 11.8379 16.5879 11.5887 16.5879 11.2812C16.5879 10.9738 16.3387 10.7246 16.0312 10.7246H2.96875C2.66134 10.7246 2.41211 10.9738 2.41211 11.2812C2.41211 11.5887 2.66134 11.8379 2.96875 11.8379H3.30273V13.6934H2.7832C1.86241 13.6934 1.11328 12.9442 1.11328 12.0234V7.57031C1.11328 6.64952 1.86241 5.90039 2.7832 5.90039H16.2168C17.1376 5.90039 17.8867 6.64952 17.8867 7.57031V12.0234Z"
                fill="#5C91F2"
              />
              <path
                d="M10.9844 13.0996H8.01562C7.70821 13.0996 7.45898 13.3488 7.45898 13.6562C7.45898 13.9637 7.70821 14.2129 8.01562 14.2129H10.9844C11.2918 14.2129 11.541 13.9637 11.541 13.6562C11.541 13.3488 11.2918 13.0996 10.9844 13.0996Z"
                fill="#5C91F2"
              />
              <path
                d="M10.9844 15.4746H8.01562C7.70821 15.4746 7.45898 15.7238 7.45898 16.0312C7.45898 16.3387 7.70821 16.5879 8.01562 16.5879H10.9844C11.2918 16.5879 11.541 16.3387 11.541 16.0312C11.541 15.7238 11.2918 15.4746 10.9844 15.4746Z"
                fill="#5C91F2"
              />
              <path
                d="M4.75 7.16211H2.96875C2.66134 7.16211 2.41211 7.41134 2.41211 7.71875C2.41211 8.02616 2.66134 8.27539 2.96875 8.27539H4.75C5.05741 8.27539 5.30664 8.02616 5.30664 7.71875C5.30664 7.41134 5.05741 7.16211 4.75 7.16211Z"
                fill="#5C91F2"
              />
            </svg>
          </div>
          <div class="payment-status__action-text">
            {{
              receiptLoading
                ? $t("loading")
                : $t("payment_status.action.print_receipt_commission")
            }}
          </div>
        </div>
        <primary-button
          :text="$t('payment_status.action.create_payment')"
          @click="toCreatePaymentPage"
        ></primary-button>
        <transparent-button
          :text="$t('payment_status.action.go_to_archive')"
          @click="toArchivePaymentsPage"
        ></transparent-button>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import TransparentButton from "@/components/buttons/TransparentButton";
import { OrderApi } from "@/office/order/order-api";

import FileSaver from "file-saver";
export default {
  name: "PaymentStatus",
  components: { TransparentButton, PrimaryButton },
  props: ["id"],
  data() {
    return {
      order: null,
      receiptLoading: false,
    };
  },
  created() {
    this.loadOrder();
  },
  computed: {
    orderTotal: function () {
      if (this.order) {
        return this.order.sum;
      }

      return 0;
    },
  },
  methods: {
    loadOrder() {
      new OrderApi()
        .loadOrder(this.id)
        .then((r) => {
          this.order = r.data.order;
        })
        .catch(() => {
          this.$router.push("/archive");
        });
    },
    loadOrderReceipts() {
      if (this.receiptLoading) {
        return;
      }

      this.receiptLoading = true;
      new OrderApi()
        .loadOrderReceipt(this.id)
        .then((r) => {
          FileSaver.saveAs(
            r.data,
            `${this.order.client.full_name}_${this.$moment(
              this.order.created_at
            ).format("DD.MM.YY hh:mm:ss")}.zip`
          );
        })
        .finally(() => {
          this.receiptLoading = false;
        });
    },
    loadOrderPDFReceipt(receiptType) {
      new OrderApi()
        .loadOrderPDFReceipt(this.order.id, receiptType)
        .then((r) => {
          FileSaver.saveAs(
            r.data,
            `Receipt-${this.order.id}-${receiptType}.pdf`
          );
        })
        .finally(() => {
          // let _index = this.orderItemReceiptsLoading.findIndex(
          //     (_item) =>
          //         _item.id === orderItemId && _item.receiptType === receiptType
          // );
          //
          // this.orderItemReceiptsLoading.splice(_index, 1);
        });
    },
    toCreatePaymentPage() {
      this.$router.push("/");
    },
    toArchivePaymentsPage() {
      this.$router.push("/archive");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";
.payment-status {
  margin-top: -50px;

  .page {
    &__title {
      margin-bottom: 26px;
    }
  }

  &__title {
    font-weight: 600;
    font-size: pxToRem(16);
    line-height: pxToRem(18);
    color: $action;
    margin-bottom: 20px;
  }

  &__amount {
    font-weight: bold;
    font-size: pxToRem(14);
    line-height: pxToRem(18);
    color: $text;
    margin-bottom: 35px;
  }

  &__content {
    padding: 32px;
    border-radius: 16px;
    border: 1px solid #f0f3fa;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #f0f3fa;
    border-radius: 16px;
    padding: 21px 25px;
    margin-bottom: 25px;

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;

      margin-right: 20px;
    }

    &-text {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &--print {
      cursor: pointer;
      transition: opacity 0.2s linear;

      &.disabled {
        opacity: 0.8;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .primary-button {
    margin-bottom: 10px;
  }
}
</style>
